<template>
  <div
    class="filters list-filters"
    v-if="!(state.hideFilters || allFiltersDisabled(state.disabledFilters))"
  >
    <div class="filters__title">
      <span>{{ state.Drupal.t("Filter by") }}</span>
    </div>
    <div class="filters__items">
      <div class="filters-item"
        v-if="
          state.disabledFilters.hasOwnProperty('title') &&
          !state.disabledFilters.title
        ">
        <div class="filters-item__filter">
          <label for="place">Słowa kluczowe</label>
          <input
            type="text"
            id="title"
            @change="updateFilter('title', $event)"
            :value="state.filters.title"
            @keyup.enter="refreshListing()"
          />
        </div>
      </div>
      <div 
        class="filters-item"
        v-if="
          state.disabledFilters.hasOwnProperty('field_event_category') &&
          !state.disabledFilters.field_event_category &&
          state.dictionaries.category.event_category
        ">
        <div class="filters-item__filter">
          <label for="type">{{ state.Drupal.t("Event category") }}</label>
          <select
            id="category"
            @change="updateFilter('category_event', $event)"
            :value="state.filters.category || -1"
            @keyup.enter="refreshListing()"
          >
            <option :value="-1">{{ state.Drupal.t("All categories") }}</option>
            <option
              :value="data.id"
              v-for="data in state.dictionaries.category.event_category"
              :key="data.id"
            >
              {{ data.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="filters-item"
        v-if="
          state.disabledFilters.hasOwnProperty('field_medical_category') &&
          !state.disabledFilters.field_medical_category &&
          state.dictionaries.category.medical_category
        ">
        <div class="filters-item__filter">
          <label for="type">{{ state.Drupal.t("Medical category") }}</label>
          <select
            id="category"
            @change="updateFilter('category_medical', $event)"
            :value="state.filters.category || -1"
            @keyup.enter="refreshListing()"
          >
            <option :value="-1">{{ state.Drupal.t("All categories") }}</option>
            <option
              :value="data.id"
              v-for="data in state.dictionaries.category.medical_category"
              :key="data.id"
            >
              {{ data.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="filters-item"
        v-if="
          state.disabledFilters.hasOwnProperty('field_lecture_category') &&
          !state.disabledFilters.field_lecture_category &&
          state.dictionaries.category.lecture_category
        "
        >
        <div class="filters-item__filter">
          <label for="type">{{ state.Drupal.t("Lecture category") }}</label>
          <select
            id="category"
            @change="updateFilter('category_lecture', $event)"
            :value="state.filters.category || -1"
            @keyup.enter="refreshListing()"
          >
            <option :value="-1">{{ state.Drupal.t("All categories") }}</option>
            <option
              :value="data.id"
              v-for="data in state.dictionaries.category.lecture_category"
              :key="data.id"
            >
              {{ data.label }}
            </option>
          </select>
        </div>
      </div>
      <div 
        class="filters-item"
        v-if="
          state.disabledFilters.hasOwnProperty('year') &&
          !state.disabledFilters.year
        ">
        <div class="filters-item__filter">
          <label class="filter-year-label" for="place">{{
            state.Drupal.t("Year")
          }}</label>
          <select
            id="year"
            @change="updateFilter('year', $event)"
            :value="state.filters.year || -1"
            @keyup.enter="refreshListing()"
          >
            <option :value="-1">{{ state.Drupal.t("All years") }}</option>
            <option :value="id" v-for="id in state.yearsAvailable" :key="id">
              {{ id }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div
      class="col btn-set-filter filters__submit"
      :class="[
        {
          'center-filter':
            state.disabledFilters.field_event_category == true ||
            state.disabledFilters.field_lecture_category == true ||
            state.disabledFilters.field_medical_category == true ||
            state.disabledFilters.title == true,
        },
      ]"
    >
        <button @click="refreshListing()">
          {{ state.Drupal.t("Search") }}
        </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Filters",
  props: ["state", "refreshListing"],
  methods: {
    updateFilter(filter, event) {
      if (event.target.value == -1) {
        delete this.state.filters[filter];
      } else {
        this.state.filters[filter] = event.target.value;
      }
      this.state.changedFilters = true;
    },
    allFiltersDisabled(disabledFilters) {
      let allDisabled = (obj) => Object.values(obj).every((v) => v === true);
      return allDisabled(disabledFilters);
    },
  },
};
</script>
